<template>
<div id="container">
   <div class="locationWrap mypage">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>마이페이지
       </strong>
     </div>
   </div>
   <div class="contents">
     <div class="inner">
       <div class="subTitWrap aniBox type_left gogo">
         <h2>회원정보관리</h2>
       </div>
       <div v-if="!isAuthed">
         <center style="font-size: 18px;">회원님의 비밀번호를 한 번 더 입력해 주세요.</center>
         <div class="inputArea">
           <dl>
             <dt>비밀번호 재확인</dt>
             <dd class="inputBox">
             <ValidationObserver v-slot="{ invalid }" ref="checkPasswdObserve">
               <ValidationProvider rules="required"  v-slot="{ errors }">
                <input type="password" name="checkPassword" class="input_ty2" placeholder="비밀번호를 입력하세요." v-model="checkPassword">
                <span class="is-invalid">{{ errors[0] }}</span>
               </ValidationProvider>
             </ValidationObserver>
             </dd>
           </dl>
         </div>

         <div class="infoBox bg_gray aniBox type_bot gogo">
           <strong>개인정보 보호를 위해 주기적으로 비밀번호를 변경해 주시고, 타인에게 비밀번호가 노출되지 않도록 주의해 주세요.</strong>
         </div>

         <div class="btn_area taC aniBox type_top gogo">
           <a href="javascript:" class="btn_blue" @click="passwordCheck">확인</a>
         </div>
       </div>
       <div v-if="isAuthed">
         <tabs>
           <tab name="myinfo" :selected="true" dispName="회원정보수정">
            <ValidationObserver v-slot="{ invalid }" ref="userUpdateObserve">
             <div class="inputArea">
               <dl>
                 <dt>아이디 <strong>*</strong><span>(이메일)</span></dt>
                 <dd class="inputBox">
                   <input type="text" name="" class="input_ty2 text-dark" placeholder="honggilDong@gmail.com" readonly v-model="userInfo.userId">
                 </dd>
               </dl>
               <dl>
                 <dt>회사명 <strong>*</strong></dt>
                 <dd class="inputBox">
                   <input type="text" name="" class="input_ty2 text-dark" placeholder="쿠첸" readonly :value="userInfo.orgInfo?userInfo.orgInfo.orgNameKor:userInfo.orgName">
                 </dd>
               </dl>
               <dl>
                 <dt>성명 <strong>*</strong></dt>
                 <dd class="inputBox">
                   <input type="text" name="" class="input_ty2 text-dark" placeholder="홍길동이" readonly v-model="userInfo.userName">
                 </dd>
               </dl>
               <dl>
                 <dt>부서명 <strong>*</strong></dt>
                 <dd class="inputBox">
                  <ValidationProvider rules="required"  v-slot="{ errors }">
                   <input type="text" name="" class="input_ty2" placeholder="상품개발팀" v-model="userInfo.partName" autocomplete="off" >
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               <dl>
                 <dt>직책 <strong>*</strong></dt>
                 <dd class="inputBox">
                  <ValidationProvider rules="required"  v-slot="{ errors }">
                   <input type="text" name="" class="input_ty2" placeholder="과장" v-model="userInfo.orgStaffPosition" autocomplete="off" >
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               <dl>
                 <dt>유선 전화번호 <strong>*</strong></dt>
                 <dd class="inputBox type_tel">
                  <ValidationProvider rules="required|integer|max:3" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength="3" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="orgPhone1" name="orgPhone1" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="setAutoTabInput(this, 'orgPhone2');" v-model="orgPhone1">
                   </ValidationProvider>
                   <ValidationProvider rules="required|integer|max:4" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength="4" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="orgPhone2" name="orgPhone2" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="setAutoTabInput(this, 'orgPhone3');" v-model="orgPhone2">
                   </ValidationProvider>
                   <ValidationProvider rules="required|integer|max:4" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength="4" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="orgPhone3" name="orgPhone3" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="setAutoTabInput(this, 'userPhone1');" v-model="orgPhone3">
                   </ValidationProvider>
                  <!--span><input type="tel" pattern="\d*" id="orgPhone1" name="orgPhone1" class="input_ty2" placeholder="" v-model="userInfo.orgPhone"></span-->
                 </dd>
               </dl>
               <dl>
                 <dt>휴대폰 <strong>*</strong></dt>
                 <dd class="inputBox type_tel">
                  <ValidationProvider rules="required|integer|max:3" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength="3" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="userPhone1" name="userPhone1" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="setAutoTabInput(this, 'userPhone2');" v-model="userPhone1">
                   </ValidationProvider>
                   <ValidationProvider rules="required|integer|max:4" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength="4" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="userPhone2" name="userPhone2" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="setAutoTabInput(this, 'userPhone3');" v-model="userPhone2">
                   </ValidationProvider>
                   <ValidationProvider rules="required|integer|max:4" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength="4" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="userPhone3" name="userPhone3" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" v-model="userPhone3">
                   </ValidationProvider>
                  <!--span><input type="tel" pattern="\d*" id="userPhone1" name="userPhone1" class="input_ty2" placeholder="" v-model="userInfo.userPhone"></span-->
                 </dd>
               </dl>
               <!--
               <dl>
                 <dt>회사주소</dt>
                 <dd class="inputBox">
                   <input type="text" name="" class="input_ty1"  v-model="userInfo.userZipcode" readonly> <a href="javascript:" class="btn_gray" @click="openJuso()">우편번호찾기</a>
                   <input type="text" name="" class="input_ty2" placeholder=""  v-model="userInfo.userAddr1" readonly>
                   <input type="text" name="" class="input_ty2" placeholder=""  v-model="userInfo.userAddr2" readonly>
                 </dd>
               </dl>
               -->
               <dl>
                 <dt>이메일 수신동의</dt>
                 <dd class="inputBox">
                   <strong>이메일 수신 여부에 동의하십니까?</strong>
                   <div>
                   <label class="radioArea"><input type="radio" name="agree" value="Y" v-model="userInfo.emailRecvYn" checked=""><span class="fakeRadiobox"></span> 동의</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                   <label class="radioArea"><input type="radio" name="agree" value="N"  v-model="userInfo.emailRecvYn"><span class="fakeRadiobox"></span> 미동의</label>
                   </div>
                   <p>※ 미동의 시 담다에서 발송되는 교육 안내 등의 정보를 수신 받을 수 없습니다.</p>
                 </dd>
               </dl>
             </div>

             <div class="btn_area taC aniBox type_top gogo">
               <a href="javascript:" class="btn_blue" @click="saveUser()">회원정보수정</a> <router-link to="/" class="btn_ty1">취소</router-link>
             </div>
             <!-- //inputArea -->
             </ValidationObserver>
           </tab>
           <tab name="password" dispName="비밀번호수정">
            <ValidationObserver v-slot="{ invalid }" ref="updatePasswordObserve">
             <div class="inputArea">
               <dl>
                 <dt>현재비밀번호</dt>
                 <dd class="inputBox">
                  <ValidationProvider rules="required"  v-slot="{ errors }">
                   <input type="password" name="oldPasswd" class="input_ty2" placeholder="현재 비밀번호를 입력하세요." v-model="rePasswd.userPasswd">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               <ValidationObserver>
               <dl>
                 <dt>새로운 비밀번호</dt>
                 <dd class="inputBox">
                 <ValidationProvider vid="confirmation" :rules="{ required:true, min:10, max:15, regex:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{10,15}$/ }" v-slot="{ errors }">
                   <input type="password" name="newPasswd" minlength=10 maxlength=15 autocomplete="off" class="input_ty2" placeholder="새로운 비밀번호를 입력하세요." v-model="rePasswd.newUserPasswd">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                   <p>영문, 숫자, 특수문자 포함하여 10~15자 이내로 입력</p>
                 </dd>
               </dl>
               <dl>
                 <dt>새로운 비밀번호 확인</dt>
                 <dd class="inputBox">
                  <ValidationProvider name="confirm" :rules="{ required:true, min:10, max:15, confirmed:'confirmation'}" v-slot="{ errors }">
                   <input type="password" name="newPasswdRe" minlength=10 maxlength=15 autocomplete="off" class="input_ty2" placeholder="새로운 비밀번호를 다시한번 입력하세요." v-model="confirmPassword">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               </ValidationObserver>
             </div>

             <div class="btn_area taC aniBox type_top gogo">
               <a href="javascript:" class="btn_blue" @click="updatePasswd()">확인</a> <router-link to="/" class="btn_ty1">취소</router-link>
             </div>
             <!-- //inputArea -->
             </ValidationObserver>
           </tab>
           <tab name="withdrawal" dispName="회원탈퇴">
            <ValidationObserver v-slot="{ invalid }" ref="dropUserObserve">
             <div class="inputArea">
               <dl>
                 <dt>비밀번호</dt>
                 <dd class="inputBox">
                  <ValidationProvider rules="required"  v-slot="{ errors }">
                   <input type="password" name="" class="input_ty2" placeholder="비밀번호를 입력하세요." v-model="dropUser.userPasswd">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
             </div>

             <div class="infoBox bg_gray aniBox type_bot gogo">
               <strong>회원 탈퇴 시 담다 포털 내 모든 정보가 삭제 되며, 이후 복구가 불가능 하오니 유의하시 탈퇴 여부를 결정 하시기 바랍니다.</strong>
               <p>회원 탈퇴 요청 후 로그인이 불가 하며, 회원 탈퇴 승인이 되면 회원정보, 기업협의회 정보 등 담다 포털 내 모든 정보가 삭제됩니다.</p>
             </div>

             <div class="btn_area taC aniBox type_top gogo">
               <a href="javascript:" class="btn_blue" @click="dropUserProc">회원탈퇴</a> <router-link to="/" class="btn_ty1">취소</router-link>
             </div>
             <!-- //inputArea -->
             </ValidationObserver>
           </tab>
         </tabs>
       </div> <!-- isAuthed -->
     </div>
   </div>
   <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"></loading>
 </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { required, email, between, confirmed, min, max, regex } from 'vee-validate/dist/rules'
import ko from 'vee-validate/dist/locale/ko.json'
import { mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

localize(ko)
extend('required', {
  ...required,
  message: '필수 입력 항목입니다.'
})
extend('email', {
  ...email,
  message: '이메일 형식이 필요합니다.'
})
extend('between', {
  ...between,
  message: '비밀번호 길이를 확인해주세요'
})
extend('confirmed', {
  ...confirmed,
  message: '비밀번호 확인값과 일치하지 않습니다.'
})
extend('min', {
  ...min,
  message: '값이 {length}자리 이상이어야 합니다.'
})
extend('max', {
  ...max,
  message: '값이 {length}자리 이하이어야 합니다.'
})
extend('regex', {
  ...regex,
  message: '비밀번호는 영문과 숫자, 특수문자가 포함되어야 합니다.'
})

Vue.component('tabs', {
  template: `
  <div class="tabs">
    <div class="myinfoTab">
      <ul class="mv_menu col3 clearfix aniBox gogo">
        <li v-for="tab in tabs">
          <a :href="tab.href" @click="selectTab(tab)" :class="{ 'active' : tab.isActive }">
            <p>{{ tab.dispName }}</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="tabs-details"><slot></slot></div>
  </div>
  `,

  data () {
    return {
      tabs: []
    }
  },

  created () {
    this.tabs = this.$children
  },

  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name)
      })
    }
  }
})

Vue.component('tab', {
  template: `
    <div v-show="isActive"><slot></slot></div>
  `,

  props: {
    name: {
      required: true
    },
    selected: {
      default: false
    },
    dispName: {
      required: false
    }
  },

  data () {
    return {
      isActive: false
    }
  },

  computed: {
    href () {
      return '#' + this.name.toLowerCase().replace(/ /g, '-')
    }
  },

  mounted () {
    this.isActive = this.selected
  }
})

export default {
  name: 'MyInfo',
  components: {
    ValidationProvider,
    ValidationObserver,
    Loading
  },
  data () {
    return {
      isAuthed: false,
      userInfo: {},
      pageInfo: [],
      rePasswd: {
        userPasswd: '',
        newUserPasswd: ''
      },
      confirmPassword: '',
      checkPassword: '',
      orgPhone1: '',
      orgPhone2: '',
      orgPhone3: '',
      userPhone1: '',
      userPhone2: '',
      userPhone3: '',
      dropUser: {
      //  userId: '',
      //  userName: '',
      //  orgName: '',
        userPasswd: ''
      },
      isLoading: false,
      fullPage: true
    }
  },
  methods: {
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    openJuso () {
      window.open('/web/api/member/jusoPopup', 'Popup', 'width=570,height=420, scrollbars=yes, resizable=yes')
    },
    saveUser () {
      var _this = this
      _this.$refs.userUpdateObserve.validate().then(valid => {
        if (valid) {
          _this.isLoading = true
          _this.userInfo.orgPhone = _this.orgPhone1 + _this.orgPhone2 + _this.orgPhone3
          _this.userInfo.userPhone = _this.userPhone1 + _this.userPhone2 + _this.userPhone3
          axios({
            method: 'PUT',
            url: '/web/api/member/',
            data: _this.userInfo,
            withCredentials: true
          }).then((response) => {
            if (response.status === 200) {
              alert('저장하였습니다. ')
              _this.isLoading = false
              window.scrollTo(0, 0)
            } else {
              alert('저장에 실패하였습니다. 잠시 후 다시 이용 부탁드립니다.')
              _this.isLoading = false
            }
          }).catch((ex) => {
            alert('오류가 발생하였습니다. 관리자에게 문의하여 주십시오')
            _this.isLoading = false
            console.log('사용자 정보 저장 오류 : ', ex)
          })
        }
      })
    },
    updatePasswd () {
      var _this = this
      _this.$refs.updatePasswordObserve.validate().then(valid => {
        if (valid) {
          _this.isLoading = true
          axios({
            method: 'PUT',
            url: '/web/api/member/passwd',
            data: this.rePasswd,
            withCredentials: true
          }).then((response) => {
            alert('저장하였습니다. ')
            _this.isLoading = false
          }).catch((ex) => {
            if (ex.response.status === 403) {
              alert('기존 비밀번호와 일치하지 않습니다.')
              _this.isLoading = false
            } else {
              alert('저장에 실패하였습니다. 잠시 후 다시 이용 부탁드립니다.')
              _this.isLoading = false
              console.log('비밀번호 변경 오류 : ', ex.response)
            }
          })
        }
      })
    },
    loadData () {
      let _this = this
      axios.get('/web/api/member/my', {withCredentials: true})
        .then(response => {
          _this.userInfo = response.data

          // Phone 설정
          var rs1 = _this.calcPhone(_this.userInfo.orgPhone)
          _this.orgPhone1 = rs1[0]
          _this.orgPhone2 = rs1[1]
          _this.orgPhone3 = rs1[2]

          var rs2 = _this.calcPhone(_this.userInfo.userPhone)
          _this.userPhone1 = rs2[0]
          _this.userPhone2 = rs2[1]
          _this.userPhone3 = rs2[2]
        })
        .catch(e => {
          console.log('error : ', e)
        })
    },
    passwordCheck () {
      var _this = this
      _this.$refs.checkPasswdObserve.validate().then(valid => {
        if (valid) {
          _this.isLoading = true
          axios.post('/web/api/member/passwordCheck', {password: _this.checkPassword})
            .then(response => {
              if (response.data) {
                _this.isAuthed = true
                _this.loadData()
              } else {
                alert('비밀번호가 일치하지 않습니다.')
              }
              _this.isLoading = false
            })
            .catch(e => {
              alert('오류가 발생하였습니다. 관리자에게 문의하여주시기 바랍니다.')
              _this.isLoading = false
              console.log('error : ', e)
            })
        }
      })
    },
    ...mapActions([ 'logout' ]),
    dropUserProc () {
      var _this = this
      _this.$refs.dropUserObserve.validate().then(valid => {
        if (valid) {
          _this.isLoading = true
          axios({
            method: 'DELETE',
            url: '/web/api/member',
            data: _this.dropUser,
            withCredentials: true
          }).then((response) => {
            alert('탈퇴되었습니다. 이용해주셔서 감사합니다.')
            _this.isLoading = false
            _this.logout().then(resp => {
            })
            location.href = '/'
          }).catch(e => {
            if (e.response.status === 404) {
              alert('정보가 일치하지 않습니다. 다시 한번 확인해주세요.')
              _this.isLoading = false
            } else {
              alert('오류가 발생하였습니다. 관리자에게 문의하여주시기 바랍니다.')
              _this.isLoading = false
              console.log('error : ', e)
            }
          })
        }
      })
    },
    calcPhone (phoneNumber) {
      phoneNumber = phoneNumber.replace(/[^0-9]/g, '')
      phoneNumber = phoneNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3')
      var rs = phoneNumber.split('-')
      rs[0] = this.nvl(rs[0], '')
      rs[1] = this.nvl(rs[1], '')
      rs[2] = this.nvl(rs[2], '')
      return rs
    },
    nvl (str, defaultStr) {
      if (typeof str === 'undefined' || str === null || str === '') {
        str = defaultStr
      }
      return str
    }
  },
  created () {
    addEventListener('setAddr', this.error)
  },
  mounted () {
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.is-invalid { color:red;  line-height: 3; padding-left: 20px;}
.is-invalid-f { border-color:red }
</style>



// WEBPACK FOOTER //
// src/components/MyInfo.vue